/* global ga:false */
export function recordEvent(...args) {
  return _recordEvent(...args);
}

const isProduction = location.host === 'cablelabs.com' || location.host === 'www.cablelabs.com';

function _recordEvent(category, action, label) {
  const data = {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  };

  if (typeof ga !== 'undefined' && isProduction) {
    console.debug('Recording event', data);
    ga('send', data);
  } else if (!isProduction) {
    console.debug('Not recording event as we are not in production', data);
  } else if (typeof ga === 'undefined') {
    console.error('Not recording event as Google Analytics is not loaded', data);
  } else {
    console.error('Not recording event for UNKNOWN REASON.', data);
  }
}
